import FeatureGates from '@atlaskit/feature-gate-js-client';

// TODO replace these usages with inline FeatureGates calls
export const useConfigBoolean = (flag: string, fallback: boolean): boolean => {
  return FeatureGates.getExperimentValue(flag, 'value', fallback);
};

export const useConfigString = (flag: string, fallback: string): string => {
  return FeatureGates.getExperimentValue(flag, 'value', fallback);
};

export const useConfigNumber = (flag: string, fallback: number): number => {
  return FeatureGates.getExperimentValue(flag, 'value', fallback);
};

export const useConfigStringList = (
  flag: string,
  fallback: string[]
): string[] => {
  return FeatureGates.getExperimentValue(flag, 'value', fallback);
};
